import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";

// Sentry.io js error tracking
Sentry.init({
  enabled: environment.sentryErrorTracking.enabled,
  dsn: "https://83cbb290caf847809e16c9a7bcc761ab@o903015.ingest.sentry.io/5842931",
  // environment: environment.production ? 'prod' : 'dev',
  environment: environment.sentryErrorTracking.environmentName,
  release: environment.appVersion,
  integrations: [
    // new Integrations.BrowserTracing({
    //   tracingOrigins: ["localhost", "https://yourserver.io/api"],
    //   routingInstrumentation: Sentry.routingInstrumentation,
    // }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
